import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css"; // Import CSS for Photo View
import "./access_control.css";

const AccessControl = () => {
  const location = useLocation();
  const storedStateName = sessionStorage.getItem("stateName");
  const { stateName = storedStateName, siteId } = location.state || {};
  const [images, setImages] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/access_control");
    }
  }, [navigate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.reload();
    }, 300000);

    return () => clearTimeout(timer);
  }, []);

  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Typography key="4" sx={{ color: "text.primary" }}>
      Access Control
    </Typography>,
  ];

  useEffect(() => {
    const fetchImages = async () => {
      const response = await fetch(
        `https://api.bharatnet.sunshineiotronics.com/api/v2/get_images_by_site_id/${siteId}`
      );
      if (response.ok) {
        const data = await response.json();
        Array.isArray(data) ? setImages(data) : setImages([]);
      } else {
        console.error("Failed to fetch images, status:", response.status);
      }
    };
    if (siteId) {
      fetchImages();
    }
  }, [siteId]);

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack spacing={2}>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="medium" />}
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Stack>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {siteId}
              </Typography>
            </Box>
            <br />
            <br />
          </div>
        </div>
      </div>
      <Card>
        <CardContent>
          {images.length === 0 ? (
            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                textAlign: "center",
                margin: "2rem 0",
                fontSize: "1.5rem",
              }}
            >
              No Images Found
            </Typography>
          ) : (
            <section className="container">
              <h1 className="my-4 centered-title">Image Gallery</h1>
              <PhotoProvider>
                <div className="gallery-grid">
                  {images.map((image) => (
                    <div className="gallery-item" key={image.id}>
                      <PhotoView src={image.file_link}>
                        <img
                          className="img-fluid img-thumbnail"
                          src={image.file_link}
                          alt={image.datetime}
                        />
                      </PhotoView>
                      <figcaption className="figure-caption">
                        <h4>{image.datetime}</h4>
                      </figcaption>
                    </div>
                  ))}
                </div>
              </PhotoProvider>
            </section>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccessControl;
